<template>
	<div>
		<Header :title="isEdit ? '修改短信配置' : '新增短信配置'" @back="onBack(false)"></Header>
		<a-spin :spinning="loading">
			<a-form style="margin-top: 30px;" ref="form" :model="modelRef" scrollToFirstError name="form"
				:labelCol="{span: 6, xxl: 5}" :wrapperCol="{span: 16, xxl: 15 }" @finish="onSubmit">
				<a-row>
					<a-col :span="24">
						<a-form-item v-if="!(id && !modelRef.cinemaCode)" name="organizationId" label="影院组织" :rules="[{ required: true, message: '必选项不允许为空' }]">
							<a-select :disabled="isSee || isEdit" placeholder="请选择" v-model:value="modelRef.organizationId" @change="getAllCinemaList">
								<a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id">
									{{ item.name }}</a-select-option>
							</a-select>
						</a-form-item>

						<a-form-item v-if="!(id && !modelRef.cinemaCode)" name="cinemaId" label="所属影院" :rules="[{ required: true, message: '必选项不允许为空' }]">
							<a-select :disabled="isSee || isEdit" placeholder="请选择" v-model:value="modelRef.cinemaId">
								<a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id">{{ item.name }}</a-select-option>
							</a-select>
						</a-form-item>

            <a-form-item label="所属影院" v-if="id && !modelRef.cinemaCode">默认配置</a-form-item>

						<a-form-item label="使用位置" name="usePosition" :rules="[{required: true, message: '请选择使用位置'}]">
							<a-radio-group v-model:value="modelRef.usePosition" :disabled="isSee">
								<a-radio :value="1">登录验证码短信</a-radio>
								<a-radio :value="2">购票失败短信</a-radio>
								<a-radio :value="3">重置会员卡密码短信</a-radio>
								<a-radio :value="4">预警信息</a-radio>
							</a-radio-group>
						</a-form-item>
            <a-form-item label="短信模板要素" v-if="modelRef.usePosition">
              <a-card>
                <div v-if="modelRef.usePosition == 1">
                  验证码： code
                </div>
                <div v-if="modelRef.usePosition == 2">
                  影院名称： name
                </div>
                <div v-if="modelRef.usePosition == 3">
                  验证码： code
                </div>
                <div v-if="modelRef.usePosition == 4">
                  <a-row>项目名称： project</a-row>
                  <a-row>影院名称： name</a-row>
                  <a-row>影院八位编码： code</a-row>
                </div>
              </a-card>
            </a-form-item>

            <a-form-item label="模板平台" name="platformFlag" :rules="[{required: true, message: '请选择模板平台'}]">
              <a-radio-group v-model:value="modelRef.platformFlag" :disabled="isSee">
                <a-radio :value="1">阿里云</a-radio>
                <a-radio :value="2">腾讯云</a-radio>
              </a-radio-group>
            </a-form-item>

						<a-form-item label="secretId" name="secretId" :rules="[{required: true, message: '必选项不允许为空'}]">
							<a-input v-model:value="modelRef.secretId" :disabled="isSee" placeholder="请输入secretId"></a-input>
						</a-form-item>

            <a-form-item label="secretKey" name="secretKey" :rules="[{required: true, message: '必选项不允许为空'}]">
              <a-input v-model:value="modelRef.secretKey" :disabled="isSee" placeholder="请输入secretKey"></a-input>
            </a-form-item>

            <a-form-item label="短信签名" name="signName" :rules="[{required: true, message: '必选项不允许为空'}]">
              <a-input v-model:value="modelRef.signName" :disabled="isSee" placeholder="请输入短信签名"></a-input>
            </a-form-item>

            <a-form-item label="短信模板" name="templateCode" :rules="[{required: true, message: '必选项不允许为空'}]">
              <a-input v-model:value="modelRef.templateCode" :disabled="isSee" placeholder="请输入短信模板"></a-input>
            </a-form-item>

            <a-form-item label="appId" name="appId" :rules="[{required: true, message: '必选项不允许为空'}]" extra="腾讯云必填"
              v-if="modelRef.platformFlag == 2">
              <a-input v-model:value="modelRef.appId" :disabled="isSee" placeholder="请输入短信模板"></a-input>
            </a-form-item>

					</a-col>
				</a-row>

				<a-row>
					<a-col :span="24" style="margin-top: 20px;text-align: center;">
						<a-button v-if="!isSee" type="primary" html-type="submit">提交</a-button>
						<a-button style="margin-left: 20px;" @click="onBack(false)">返回</a-button>
					</a-col>
				</a-row>
			</a-form>

		</a-spin>
	</div>
</template>

<script>
	import Header from '@/components/header/header.vue';

	import {
		getOrganizationList,
		getCinemaList,
	} from '@/service/modules/cinema.js';

  import {
    getSmsDetail,
    editSms,
    saveSms
  } from "@/service/modules/system";
	export default {
		components: {
			Header,
		},
		props: {
			isEdit: {
				type: Boolean,
				default: true
			},
			id: {
				type: Number,
				default: 0
			},
			isSee: {
				type: Boolean,
				default: false
			}
		},
		created() {
			this.getOrganizationList();
			if (this.id) {
				this.getData();
			}
		},
		data() {
			return {
				loading: false,
				organizationList: [],
				cinemaAllList: [],
				cinemaIds: [],
				modelRef: {
				},
			}
		},
		methods: {
			onBack(isRef) {
				this.$emit('back', isRef);
			},
			async getData() {
				this.loading = true;
				try {
					let ret = await getSmsDetail({
						id: this.id
					});
					this.loading = false;
					if (ret.code === 200) {
						if (ret.data.timeList) {
							this.timeList = JSON.parse(ret.data.timeList).map(item => {
								return {
									time: [this.moment(item.startTime * 1000), this.moment(item.endTime * 1000)]
								}
							});
						}

						this.getAllCinemaList(ret.data.organizationId);
						this.modelRef = ret.data;
					}
				} catch (e) {
					this.loading = false;
				}
			},
			async getAllCinemaList(organizationId) {
				this.cinemaAllList = [];
				this.modelRef.cinemaId = undefined;
				let ret = await getCinemaList({
					page: 1,
					pageSize: 999999,
					organizationId: organizationId ? organizationId : undefined
				})
				if (ret.code === 200) {
					this.cinemaAllList = ret.data.list;
				}
			},
			async onSubmit() {
				let postData = JSON.parse(JSON.stringify(this.modelRef));
				try {
					let ret;
					this.loading = true;
					if (this.isEdit && this.id) {
						postData.id = this.id;
						ret = await editSms(postData);
					} else {
						ret = await saveSms(postData);
					}
					this.loading = false;
					if (ret.code === 200) {
						this.$message.success('操作成功');
						this.onBack(true);
					}
				} catch (e) {
					this.loading = false;
				}
			},
			async getOrganizationList() {
				let ret = await getOrganizationList({
					page: 1,
					pageSize: 999999
				});
				this.organizationList = ret.data.list || [];
			},
		}
	}
</script>

<!--<style scoped>

</style>-->
